import type {
  AgentDecisionCheckoutChannel,
  AgentDecisionCommerceSystem,
} from "@ishvaram/api-client";

export const ISHVARAM_COMMERCE_SYSTEM = "ishvaram" satisfies AgentDecisionCommerceSystem;
export const SHOPIFY_COMMERCE_SYSTEM = "shopify" satisfies AgentDecisionCommerceSystem;

export const ISHVARAM_NATIVE_CART_CHECKOUT_CHANNEL =
  "ishvaram_native_cart" satisfies AgentDecisionCheckoutChannel;
export const ISHVARAM_REPORT_CHECKOUT_CHANNEL =
  "ishvaram_report" satisfies AgentDecisionCheckoutChannel;
export const SHOPIFY_PRODUCT_CHECKOUT_CHANNEL =
  "shopify_product" satisfies AgentDecisionCheckoutChannel;
